import { MapPin } from 'lucide-react';
import { formatStationAddress } from '@/domain/address';
import { formatDistanceKm, type StationWithDistance } from '@/domain/geo';
import type { Dictionary, Locale } from '@/i18n';

type StationListProps = {
  dict: Dictionary;
  locale: Locale;
  stations: readonly StationWithDistance[];
  isMapFallback?: boolean;
};

export const StationList = ({ dict, locale, stations, isMapFallback }: StationListProps) => (
  <div className="flex flex-col gap-3">
    <h3 className="text-[11px] font-bold uppercase tracking-[0.08em] text-grey-800">
      {dict.map.listTitle}
    </h3>
    {isMapFallback === true ? (
      <p className="text-sm text-grey-800">{dict.map.unavailable}</p>
    ) : null}
    <ul className="flex flex-col divide-y divide-grey-200 rounded-xl border border-grey-200">
      {stations.map((station) => (
        <li
          key={`${station.lat},${station.lon}`}
          className="flex items-start justify-between gap-3 p-3"
        >
          <span className="flex items-start gap-2 text-sm text-black">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-grey-800" aria-hidden="true" />
            {formatStationAddress(station.address)}
          </span>
          <span className="shrink-0 text-sm font-semibold tabular-nums text-grey-800">
            {formatDistanceKm(station.distanceKm, locale)}
          </span>
        </li>
      ))}
    </ul>
  </div>
);
